export type ObjectChoice = { kind: 'none' } | { kind: 'choose' } | { kind: 'selected'; objectId: number };

/** Which screen follows login, given GET /v1/profile/objects and the id saved in CloudStorage. */
export function chooseObject(objects: ReadonlyArray<{ id: number }>, savedId: string | null): ObjectChoice {
  if (objects.length === 0) return { kind: 'none' };
  if (objects.length === 1) return { kind: 'selected', objectId: objects[0].id };
  const saved = objects.find((o) => String(o.id) === savedId);
  return saved ? { kind: 'selected', objectId: saved.id } : { kind: 'choose' };
}
